<template>
  <div class="header">
    <div class="header_main">
      <img src="@/assets/images/logo_w.png" class="logo" title="舟山市龙山船厂有限公司" alt="舟山市龙山船厂有限公司">
      <div class="header_nav">

        <div class="nav_item"
        :class="type == item.href ?'curr':''"
        :style="language == 'EN'?'padding:0 10px':'padding:0 20px'"
        @click="goUrl(item.href,item.func)"
        v-for="(item,index) in menu_list" :key="index">
          {{item.title}}
        </div>

        <!--
        <div class="nav_item" :class="type == 'index' ?'curr':''" @click="goUrl('')">
          {{language == 'EN'?'Home':'首页'}}
        </div>
        <div class="nav_item" :class="type == 'about' ?'curr':''" @click="goUrl('about')">
          {{language == 'EN'?'About Us':'关于我们'}}
        </div>
        <div class="nav_item" :class="type == 'news' ?'curr':''" @click="goUrl('news')">
          {{language == 'EN'?'News Center':'新闻中心'}}
        </div>
        <div class="nav_item" :class="type == 'business' ?'curr':''" @click="goUrl('business')">
          {{language == 'EN'?'Business':'经营领域'}}
        </div>
        <div class="nav_item" :class="type == 'facilities' ?'curr':''" @click="goUrl('facilities')">
          {{language == 'EN'?'Facilities':'设施设备'}}
        </div>
        <div class="nav_item" :class="type == 'resources' ?'curr':''" @click="goUrl('resources')">
          {{language == 'EN'?'Join Us':'人力资源'}}
        </div>
        <div class="nav_item" :class="type == 'contact' ?'curr':''" @click="goUrl('contact')">
          {{language == 'EN'?'Contact':'联系我们'}}
        </div>
        -->

        <div class="search_box">
          <div class="search_item">
            <input type="text" :placeholder="language == 'EN'?'search':'搜索'" v-model="keywords">
            <img src="@/assets/images/ico_search.png" class="ico_search" width="25" @click="hrefFun()">
          </div>
        </div>
        <div class="lan_box">
          <div class="flex flexa" @click="showLan()" style="width:60px">{{language}} <img src="@/assets/images/ico_down.png" class="ml3" width="20"></div>
          <div class="lan_show_box" v-if="is_show_lan == true">
            <a href="javascript:;" @click="setLan('EN')">English(EN)</a>
            <a href="javascript:;" @click="setLan('CH')">简体中文(CH)</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getMenu} from "@/request/api";
export default {
  name: 'Header',
  props: {
    type: { // 数据类型
      type: String,
      default: '',
    }
  },
  data () {
    return {
      keywords:'',
      language:localStorage.getItem('language') || 'CH',
      is_show_lan:false,
      menu_list:[],
      func:'', //存储头部跳转的func 搜索字段
    }
  },
  created (){
    this.getMenu()
  },
  methods:{
    getMenu(){
      var that = this
      getMenu().then(res=>{
        that.menu_list = res.data.menu
      }).catch(function (error) {
          console.log(error);
      });
    },
    goUrl(url,func){
      this.func = func
      this.$router.push({ path: '/'+url });
    },
    hrefFun(){
      if(this.keywords){
        this.$router.push('/news?keywords='+this.keywords+'&type=all')
      }
      this.keywords = ''
    },
    showLan(){
      this.is_show_lan = !this.is_show_lan
    },
    setLan(lan){
      this.language = lan
      this.is_show_lan = false
      localStorage.setItem('language',lan)
      window.location.reload()
    },


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header{
  position: absolute;
  top:0;
  left: 0;
  width: 100%;
  height: 120px;
  background-color: rgba(11, 33, 67, .7);
  z-index: 9999;
}
.header_main{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  max-width: 1500px;
  height: 120px;
  color:#fff;

}
.logo{
  width: 340px;
}
.header_nav{
  display: flex;
  justify-content: flex-end;
  font-size: 16px;
  height: 120px;
  line-height: 120px;
  font-weight: 400;
}
.header_nav .nav_item{
  color:#fff;
  padding: 0 25px;
  cursor: pointer;
  overflow: hidden;
}
.header_nav .nav_item:hover{
  background-color: rgba(27, 68, 132, .5);
}
.header_nav .nav_item.curr{
  background-color: #1B4484;
}
.search_box{
  display: flex;
  align-items: center;
  height: 120px;
  margin-left: 15px;
  margin-right: 20px;
}
.search_item{
  position: relative;
  width: 160px;
  height: 35px;
  background: rgba(34, 34, 34, .5);
  border-radius: 4px;
  border: 1px solid rgba(112, 112, 112, .7);
}
.search_box input{
  position: absolute;
  right: 0;
  top:0;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  background: none;
  border: none;
  padding-left: 10px;
  font-size: 16px;
  color: #fff;
}
.search_box input::input-placeholder{
	color:#efefef;
}
.search_box .ico_search{
  position: absolute;
  right: 5px;
  top:5px;
}
.lan_box{
  /* flex-grow: 1; */
  position: relative;
  cursor: pointer;
}
.lan_show_box{
  position: absolute;
  top:90px;
  left:-50px;
  width: 130px;
  padding: 5px 0;
  border-radius: 3px;
  background-color: rgba(27, 68, 132, .7);
}
.lan_show_box:after{
  content: "";
  display: block;
  position: absolute;
  top: -29px;
  left: 50%;
  width: 0;
  height: 0;
  border:15px solid;
  margin-left: -15px;
  border-color: transparent transparent rgba(27, 68, 132, .7);
}
.lan_show_box a{
  display: block;
  height: 35px;
  color: #fff;
  line-height: 35px;
  text-align: center;
}
.lan_show_box a:hover{
  background-color: rgba(27, 68, 132, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue